import { TrendingUp, Crown } from 'lucide-react';
import './league-max-prize.css';
import { LeagueMaxPrizeProps } from './league-max-prize.props';
import { useGetLeague } from '../../../hooks';
import { useLeaguePrizePool } from '../../../hooks';

export function LeagueMaxPrize({ league }: LeagueMaxPrizeProps) {
  const { currentSeason, loading, asyncLeague } = useGetLeague(league);
  const { totalPrizePool } = useLeaguePrizePool(
    asyncLeague?.loot.total ?? 0,
    currentSeason,
  );

  if (loading || !currentSeason) return null;

  return (
    <div className="league-max-prize">
      <Crown className="league-max-prize-icon crown" />

      <div className="league-max-prize-text">
        <div className="label">Botín a repartir</div>
        <div className="value">
          <small>Hasta</small> €
          {totalPrizePool.toLocaleString('es-ES', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          })}
        </div>
      </div>

      <TrendingUp className="league-max-prize-icon trend" />
    </div>
  );
}
